import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
// caveats of using mixin in vue class component
// https://github.com/vuejs/vue-class-component#using-mixins
// https://stackoverflow.com/a/51874143
let ViewRendererMixin = 
/**
 * Grid and List View Renderer Mixin
 *
 */
class ViewRendererMixin extends Vue {
    constructor() {
        super(...arguments);
        this.gridLayoutOptions = {
            icon: 'view_module',
            name: 'grid',
        };
        this.listLayoutOptions = {
            icon: 'format_list_bulleted',
            name: 'list',
        };
        this.gridProductsLayoutOptions = {
            icon: 'view_module',
            name: 'grid',
        };
        this.listProductsLayoutOptions = {
            icon: 'format_list_bulleted',
            name: 'list',
        };
        this.selectedComponentLayoutOptions = this.listLayoutOptions;
        this.selectedProductsComponentLayoutOptions = this.gridLayoutOptions;
    }
    changeRenderedView() {
        // Change rendered view based on selected view option(list/grid)
        if (this.selectedComponentLayoutOptions === this.gridLayoutOptions) {
            this.selectedComponentLayoutOptions = this.listLayoutOptions;
            this.setViewLayoutMode(this.listLayoutOptions.name);
        }
        else {
            this.selectedComponentLayoutOptions = this.gridLayoutOptions;
            this.setViewLayoutMode(this.gridLayoutOptions.name);
        }
    }
    changeProductsRenderedView() {
        // Change rendered view based on selected view option(list/grid)
        if (this.selectedProductsComponentLayoutOptions === this.gridLayoutOptions) {
            this.selectedProductsComponentLayoutOptions = this.listLayoutOptions;
            this.setProductsViewLayoutMode(this.listLayoutOptions.name);
        }
        else {
            this.selectedProductsComponentLayoutOptions = this.gridLayoutOptions;
            this.setProductsViewLayoutMode(this.gridLayoutOptions.name);
        }
    }
};
__decorate([
    Mutation('setViewLayoutMode')
], ViewRendererMixin.prototype, "setViewLayoutMode", void 0);
__decorate([
    Mutation('setProductsViewLayoutMode')
], ViewRendererMixin.prototype, "setProductsViewLayoutMode", void 0);
ViewRendererMixin = __decorate([
    Component
    /**
     * Grid and List View Renderer Mixin
     *
     */
], ViewRendererMixin);
export default ViewRendererMixin;
